/**
 * Copyright © Veeam Software Group GmbH.
 */

import { createContext } from 'react';

import type { ManagedVmsStore } from '../stores/ManagedVmsStore';

export const ManagedVmsContext = createContext<ManagedVmsStore>({} as ManagedVmsStore);
